import React, { Suspense, useContext } from "react";
import { Route, Switch } from "react-router-dom";
import { logout } from "./../reusable/common";
import AllRoutes from "./Routes";
import AuthContext from "./../contexts/AuthContext";
import KonfhubLoad from "../components/KonfhubLoad";
import DashboardRoutes from "./DashboardRoutes";
import OtherRoutes from "./OtherRoutes";
import CommunityRoutes from "./CommunityRoutes";
import { baseUrl } from "../config/config";
import StripeConnect from "../revampPages/StaticPage/StripeConnect";
import Outage from "../revampPages/Outage";
import EventDashboardRoutes from "./EventDashboardRoutes";
import EventProfileDetailsRoute from "./EventProfileDetailsRoute";

const Page404 = React.lazy(() => import("./../pages/Page404"));

export default function Routes(props) {
	const Context = useContext(AuthContext);

	return (
		<Suspense fallback={<KonfhubLoad />}>
			<Switch>
				{/* Logout route */}
				<Route
					path="/logout"
					component={props => {
						logout();
						Context.setAuth({}, false);
						// return <Redirect to="/" />;
						window.location.href = baseUrl;
						//return <></>
					}}
				/>


				<Route
					exact
					path={["/", "/manage-events", "/event-profile", "/reports"]}
					component={EventDashboardRoutes}
				/>

				<Route
					exact={false}
					path={["/event-profile/:profileId/organizer-details", "/event-profile/:profileId/team", "/event-profile/:profileId/white-label", "/event-profile/:profileId/associated-events"]}
					component={EventProfileDetailsRoute}
				/>

				{/* Outage page */}
				<Route path="/outage">
					<Outage {...props} />
				</Route>

				{/* Community routes */}
				<Route path="/my-community">
					<CommunityRoutes {...props} />
				</Route>

				{/* Create Event routes */}
				<Route path="/create">
					<OtherRoutes {...props} />
				</Route>

				{/* Dashboard routes with eventId */}
				<Route path="/e/:eventId/">
					<DashboardRoutes {...props} />
				</Route>

				{/* Stripe Connect */}
				<Route path="/connect-stripe">
					<StripeConnect {...props} />
				</Route>

				{/* Default 404 page */}
				<Route component={Page404} />
			</Switch>
		</Suspense>
	);
}
